export default __webpack_public_path__ + "static/media/customer-login.f80a5e77.png";